const pass = (rule, value, callback) => {
  if (value) {
    callback();
  } else {
    callback();
  }
};
export const warehouseGoodsOption = {
  align: "center",
  menuAlign: "center",
  headerAlign: "center",
  border: true,
  expand: false,
  stripe: false,
  showHeader: true,
  index: false,
  selection: true,
  menu: true,
  page: true,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  addTitle: '新增入库',
  menuWidth: "300",
  labelWidth: "150",
  defaultSort: {
    prop: "createTime",
    order: "descending",
  },
  column: [
    {
      label: "产品类型",
      prop: "type",
      type: "select",
      addVisdiplay: false,
      editVisdiplay: false,
      search: true,
      dicData: [
        {
          label: "防水",
          value: "WATERPROOF",
        },
        {
          label: "净水",
          value: "PURE_WATER",
        },
        {
          label: "吊顶",
          value: "HANG_CEILING",
        }
      ],
    },
    {
      label: "产品",
      prop: "goodsName",
      search: true,
      formsolt: true,
      rules: [
        {
          required: true,
          trigger: "change",
          validator: pass,
        },
      ],
    },
    {
      label: "产品库存",
      prop: "num",
      type: "input",
      rules: [
        {
          required: true,
          trigger: "change",
          validator: pass,
        },
      ],
    },
    {
      label: "待入库数量",
      prop: "unStockQuantity",
      type: "input",
      solt: true,
      addVisdiplay: false,
      editVisdiplay: false,
    },
  ],
};
